import { useWorkspaceInfo } from '@affine/core/components/hooks/use-workspace-info';
import { ServerService } from '@affine/core/modules/cloud';
import { WorkspaceService } from '@affine/core/modules/workspace';
import { useLiveData, useService } from '@toeverything/infra';
import { useMemo } from 'react';

/**
 * Single visibility rule for the workspace Plans surface: cloud workspaces on
 * a payment-enabled server, for workspace owners and admins only. The settings
 * sidebar and plan-gated CTAs share it so a CTA never opens a hidden tab.
 */
export function useCanOpenWorkspacePlans(): boolean {
  const workspace = useService(WorkspaceService).workspace;
  const serverService = useService(ServerService);
  const information = useWorkspaceInfo(workspace);
  const hasPaymentFeature = useLiveData(
    useMemo(
      () => serverService.server.features$.map(f => f?.payment === true),
      [serverService]
    )
  );
  return (
    workspace.flavour !== 'local' &&
    hasPaymentFeature &&
    (information?.isOwner === true || information?.isAdmin === true)
  );
}
